'use client';
import { createPortal } from 'react-dom';

type Props = {
  rect: DOMRect;
  offset?: number;
  children: React.ReactNode;
};

export function SelectionMenuPortal({ rect, offset = 8, children }: Props) {
  return createPortal(
    <div
      style={{
        position: 'fixed',
        top: rect.top - offset,
        left: rect.left + rect.width / 2,
        transform: 'translate(-50%, -100%)',
        zIndex: 9999,
        userSelect: 'none',
      }}
      onMouseDown={(e) => e.preventDefault()}
    >
      {children}
    </div>,
    document.body,
  );
}
